import Link from 'next/link';
import Image from 'next/image';
import { cn } from '@/lib/utils';

/**
 * Logo component for Upbeat Brain Game.
 * Simplified structure to ensure 100% hydration consistency between server and client.
 */
export function Logo({ className }: { className?: string }) {
  return (
    <Link href="/" className="flex items-center gap-2 group">
      <div className="relative w-10 h-10 overflow-hidden rounded-full transition-transform group-hover:scale-110 border-2 border-primary/20 bg-white shadow-sm flex-shrink-0">
        <Image
          src="https://i.postimg.cc/sxSMDjTL/logo.jpg"
          alt="Upbeat Brain Game Logo"
          fill
          className="object-contain"
          sizes="40px"
          priority
        />
      </div>
      <span className={cn("text-xl font-bold font-headline text-foreground tracking-tight whitespace-nowrap", className)}>
        Upbeat Brain Game
      </span>
    </Link>
  );
}
